import React from 'react';
import './AboutUs.css';
import aboutUsImage from '../assets/about.jpg';

const AboutUs = () => {
  return (
    <section className="about-us" id="about">
      <div className="about-container">
        {/* Background Elements */}
        <div className="bg-elements">
          <div className="bg-circle bg-circle-1"></div>
          <div className="bg-circle bg-circle-2"></div>
          <div className="bg-pattern"></div>
        </div>

        <div className="about-content">
          {/* Left Side - Stats & Image */}
          <div className="about-left">
           

            <div className="image-showcase">
              <div className="main-image">
                <img 
                  src={aboutUsImage} 
                  alt="Chef preparing Indian cuisine" 
                  className="chef-image"
                />
               
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="about-right">
            <div className="content-wrapper">
             
              {/* Main Heading */}
              <h2 className="about-heading">
                Crafting Authentic Indian Flavors Since 1234
              </h2>

              {/* Description */}
              <p className="about-description">
                We are passionate about bringing you the most authentic Indian dining experience. 
                Our master chefs use traditional techniques and the finest spices to create dishes 
                that tell the story of India's rich culinary heritage.
              </p>

              {/* Features Grid */}
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon">
                    <div className="icon-wrapper">
                      <i className="fas fa-book-open"></i>
                    </div>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Authentic Recipes</h4>
                    
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <div className="icon-wrapper">
                      <i className="fas fa-pepper-hot"></i>
                    </div>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Premium Spices</h4>
                    
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <div className="icon-wrapper">
                      <i className="fas fa-user-tie"></i>
                    </div>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Expert Chefs</h4>
                    
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <div className="icon-wrapper">
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Quality Service</h4>
                    
                  </div>
                </div>
              </div>

              {/* Call to Action Buttons */}
              <div className="cta-buttons">
                
                <button className="secondary-btn">
                  View Menu
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
